"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const timeZones = Object.freeze({
    ASIA_TOKYO: "Asia/Tokyo",
});
exports.default = timeZones;
